// extracted by mini-css-extract-plugin
module.exports = {"siteNotifications":"SiteNotification_siteNotifications__v3308","notificationItem":"SiteNotification_notificationItem__eF3So"};